import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import { styled, Theme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const ContentWrapperBox = styled(Box)(({ theme }: { theme: Theme }) => ({
    textAlign: "left",
    padding: theme.spacing(4),
    maxWidth: "550px",
})) as typeof Box;

export const EmptyStateIconBox = styled(Box)(({ theme }: { theme: Theme }) => ({
    marginBottom: theme.spacing(4),
})) as typeof Box;

export const TitleTypography = styled(Typography)(({ theme }: { theme: Theme }) => ({
    fontSize: theme.typography.h6.fontSize,
    fontWeight: "700",
    lineHeight: "26px",
    marginBottom: theme.spacing(0),
})) as typeof Typography;

export const BodyTypography = styled(Typography)(({ theme }: { theme: Theme }) => ({
    color: theme.palette.text.primary,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: "400",
    lineHeight: "24px",
})) as typeof Typography;

export const ActionButtonBox = styled(Box)(({ theme }: { theme: Theme }) => ({
    width: "fit-content",
    display: "flex",
    justifyContent: "space-between",
    columnGap: theme.spacing(1.25),
    marginTop: theme.spacing(4),
})) as typeof Box;

export const DefaultIcon = styled(Icon)(({ theme }: { theme: Theme }) => ({
    color: theme.palette.error.main,
    fontSize: theme.typography.h2.fontSize,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
